import { Suspense, type FC, type PropsWithChildren, type ReactElement } from 'react'

type AnyProps = Exclude<object, null>

export interface LoadingComponentSuspenseBoundaryProps<Props extends AnyProps> extends PropsWithChildren {
  mainComponentProps: Props
  fallback: ReactElement | null | FC<Props>
}

export const LoadingComponentSuspenseBoundary = <Props extends AnyProps>(
  props: LoadingComponentSuspenseBoundaryProps<Props>
): ReturnType<FC> => {
  const { fallback: Fallback, mainComponentProps, children } = props

  const fallbackNode = typeof Fallback === 'function' ? <Fallback {...mainComponentProps} /> : Fallback

  return <Suspense fallback={fallbackNode}>{children}</Suspense>
}
